import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthStore } from '@/stores/authStore';
import { logger } from '@/utils/logger';

/**
 * OAuth logout callback page
 *
 * When Cognito redirects after sign-out, this page ensures local state
 * is cleared and redirects to the login page.
 */
export default function AuthLogout() {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  useEffect(() => {
    async function handleLogout() {
      logger.debug('OAuth logout callback: clearing local state');
      await logout();
      navigate('/login', { replace: true });
    }
    handleLogout();
  }, [logout, navigate]);

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center p-4">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto mb-4" />
        <p className="text-purple-300 text-lg">Signing out...</p>
      </div>
    </div>
  );
}
